export default "__VITE_ASSET__D6npEiQm__"